import { render, staticRenderFns } from "./AdminPaymentSettings.vue?vue&type=template&id=002e9748&scoped=true"
import script from "./AdminPaymentSettings.vue?vue&type=script&lang=js"
export * from "./AdminPaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminPaymentSettings.vue?vue&type=style&index=0&id=002e9748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002e9748",
  null
  
)

export default component.exports